import {NgModule} from '@angular/core';
import {TooltipComponent} from './tooltip.component';

@NgModule({
    exports: [TooltipComponent],
    declarations: [TooltipComponent]
})
export class TooltipModule {
}